// extracted by mini-css-extract-plugin
export default {"MainButton":"MainButton_MainButton__OecKH","Shimiring":"MainButton_Shimiring__CI3WA"};